/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_LATO_BOLD: 'LatoBold, sans-serif',
  FONT_LATO_REGULAR: 'LatoRegular, sans-serif',
  FONT_ARVO_BOLD: 'ArvoBold, serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_500: '500',
  //Mobile values
  //H1
  FONT_SIZE_H1: '36px',
  LINE_HEIGHT_H1: '46px',
  LETTER_SPACING_H1: 'normal',
  //H2
  FONT_SIZE_H2: '24px',
  LINE_HEIGHT_H2: '34px',
  LETTER_SPACING_H2: '2.16px',
  //H3
  FONT_SIZE_H3: '18px',
  LINE_HEIGHT_H3: '21px',
  LETTER_SPACING_H3: '1.62px',
  //H4
  FONT_SIZE_H4: '15px',
  LINE_HEIGHT_H4: '28px',
  LETTER_SPACING_H4: '1.35px',
  //H5
  FONT_SIZE_H5: '13px',
  LINE_HEIGHT_H5: '16px',
  LETTER_SPACING_H5: '0.13px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '28px',
  LETTER_SPACING_P: 'normal',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '70px',
    LINE_HEIGHT_H1: '80px',
    LETTER_SPACING_H1: 'normal',
    //H2
    FONT_SIZE_H2: '30px',
    LINE_HEIGHT_H2: '40px',
    LETTER_SPACING_H2: '2.7px',
    //H3
    FONT_SIZE_H3: '20px',
    LINE_HEIGHT_H3: '26px',
    LETTER_SPACING_H3: '1.8px',
    //H4
    FONT_SIZE_H4: '15px',
    LINE_HEIGHT_H4: '24px',
    LETTER_SPACING_H4: '1.35px',
    //H5
    FONT_SIZE_H5: '13px',
    LINE_HEIGHT_H5: '21px',
    LETTER_SPACING_H5: '0.13px',
    //P
    FONT_SIZE_P: '16px',
    LINE_HEIGHT_P: '30px',
    LETTER_SPACING_P: 'normal'
  },
  FONT_FACES: ['LatoBold', 'LatoRegular', 'ArvoBold']
};